/**
 * Returns true if the allocation actively consumes a license seat.
 * Exempt users have a license assigned but are excluded from seat counts.
 */
export const consumesLicenseSeat = (allocation: { License: boolean | null | undefined; User: { ExemptLicense: boolean } }): boolean =>
  !!allocation.License && !allocation.User.ExemptLicense;
